import { Dialog } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { LOGO } from "../../assets/index";
import { main } from "../../routes/main";
import { useAuth } from "../Auth/useAuth";
import UiButton, { UI_BUTTON_TYPE } from "../ui/UiButton";
import ContactCardGroup from "./ContactCardGroup/ContactCardGroup";
import "./Footer.css";
import LanguageDropdown from "./LanguageDropdown/LanguageDropdown";
import NewsletterCollector from "./NewsletterCollector/NewsletterCollector";

function Footer({
  appVersion,
  currentLanguage,
  handleLanguageChange = () => {},
}) {
  const [auth, { isRoleClient }] = useAuth();
  const [isUserLoggedIn, setIsLoggedIn] = useState(false);
  const [NewsletterForm, isNewsletterForm] = useState(false);
  const [contactsInfos, setcontactsInfos] = useState([]);
  const clientOfOperator = auth?.user?.client_profile;
  const isClient = isRoleClient();
  useEffect(() => {
    const defaultContacts = {
      name: "",
      departName: "Pôle Client",
      mobile: "+33 6 58 39 52 79",
      email: "advfrance@blancreme.com",
    };

    if (auth && auth?.user && auth.user?.id && auth.is_confirmed) {
      setIsLoggedIn(true);
      const user = auth?.user;
      const vrp = user?.data?.vrp;

      let contact;
      if (vrp?.NOMOPE || clientOfOperator?.id) {
        const { NOMOPE, TEL, EMAIL } = vrp || {
          NOMOPE: user?.data?.name,
          TEL: user?.data?.tel,
          EMAIL: user?.data?.email,
        };
        contact = {
          departName: "Contact commercial",
          name: NOMOPE,
          mobile: TEL || "",
          email: EMAIL || "",
        };
      } else {
        setcontactsInfos([defaultContacts]);
        return;
      }

      setcontactsInfos([defaultContacts, contact]);
    } else {
      setIsLoggedIn(false);
      setcontactsInfos([defaultContacts]);
    }
  }, [auth, isClient, clientOfOperator]);

  function FooterWrapper({ containerOne, containerTwo }) {
    return (
      <React.Fragment>
        <div className="footer-container">
          {containerOne}
          {containerTwo}
        </div>
      </React.Fragment>
    );
  }

  function FooterGraphic({
    image,
    altText,
    className,
    url,
    isOpenInNewTab = false,
  }) {
    return (
      <React.Fragment>
        <a
          className="footer-graphic-link"
          href={url || main.HOME.path}
          target={isOpenInNewTab ? "_blank" : "_self"}
        >
          <img
            src={image}
            alt={altText || "Footer Graphic"}
            className={className}
          />
        </a>
      </React.Fragment>
    );
  }

  function FooterSectionTitle({ title }) {
    return (
      <React.Fragment>
        <div className="footer-title">{title}</div>
      </React.Fragment>
    );
  }

  function renderSocialMediaIcons() {
    return (
      <React.Fragment>
        <div className="social-media-icons">
          <FooterGraphic
            image={LOGO.facebookLogo}
            altText={"facebook-logo"}
            className={"social-icon"}
            url={"https://www.facebook.com/groups/blancremepartenaires"}
            isOpenInNewTab={true}
          />
          <FooterGraphic
            image={LOGO.instagramLogo}
            altText={"instagram-logo"}
            className={"social-icon"}
            url={"https://www.instagram.com/blancreme_instituts"}
            isOpenInNewTab={true}
          />
        </div>
      </React.Fragment>
    );
  }

  function renderNewsletter() {
    return (
      <React.Fragment>
        <FooterWrapper
          containerOne={<FooterSectionTitle title={"Newsletter pro"} />}
          containerTwo={
            <React.Fragment>
              <div className="newsletter-section">
                <span className="newsletter-description">
                  Abonnez-vous pour ne rien manquer !
                </span>
                <UiButton
                  content="Je m’abonne"
                  buttonUiType={[
                    UI_BUTTON_TYPE.ONLY_BORDER,
                    UI_BUTTON_TYPE.BG_WHITE,
                  ]}
                  style={{ width: "131px" }}
                  onClick={() => {
                    isNewsletterForm(true);
                  }}
                  size="sm"
                />
              </div>
            </React.Fragment>
          }
        />
      </React.Fragment>
    );
  }

  if (isUserLoggedIn) {
    return (
      <React.Fragment>
        <div className="footer">
          <FooterWrapper
            containerOne={FooterGraphic({
              image: LOGO.appFooterBrandLogo,
              altText: "logo",
              className: "footer-logo",
            })}
            containerTwo={
              <React.Fragment>
                <div className="app-version">{appVersion}</div>
                {/* <LanguageDropdown
                  onLanguageSelect={(e) => handleLanguageChange(e)}
                  currentLanguage={currentLanguage}
                /> */}
              </React.Fragment>
            }
          />
          <FooterWrapper
            containerOne={FooterSectionTitle({ title: "Contacts" })}
            containerTwo={ContactCardGroup({ contactsInfo: contactsInfos })}
          />
          <FooterWrapper
            containerOne={FooterSectionTitle({
              title: "Rejoignez nos groupes pro",
            })}
            containerTwo={renderSocialMediaIcons()}
          />
          {renderNewsletter()}
        </div>
        <Dialog open={NewsletterForm} onClose={() => isNewsletterForm(false)}>
          <NewsletterCollector close={() => isNewsletterForm(false)} />
        </Dialog>
      </React.Fragment>
    );
  } else {
    return <React.Fragment></React.Fragment>;
  }
}

export default Footer;
